
import './App.css';
import TopNav from './components/TopNav';
import HeroSec from './components/HeroSec';
import Flow from './components/Flow';
import Footer from './components/Footer';


function App() {
  return (
    <>
    <TopNav/>
    <HeroSec/>
    <Flow/>
    <Footer/>
    </>
    
  );
}

export default App;
